import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from "react";
import AskForScopeAdmin from "./AskForScopeAdmin";
import ScopeLoader from "./ScopeLoader";

const LinkedQuoteTabContent = ({ linkedQuoteId, userType, queryInfo, loopUserObject }) => {
    const [linkedRefId, setLinkedRefId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLinkedRefId = async () => {
            try {
                const response = await fetch("https://noodlesbox.in/loopback/api/scope/getRefId", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ scope_id: linkedQuoteId }),
                });
                const data = await response.json();
                if (data.status) {
                    setLinkedRefId(data.data.ref_id);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        if (linkedQuoteId) fetchLinkedRefId();
    }, [linkedQuoteId]);

    if (loading) return <ScopeLoader />;
    if (!linkedRefId) return <div className="p-3 text-red-500 font-semibold">Failed to load linked quote details (Quote ID: {linkedQuoteId}).</div>;

    return (
        <div className="linked-quote-container border rounded bg-white overflow-hidden shadow-sm">
            <AskForScopeAdmin
                queryId={linkedRefId}
                userType={userType}
                quotationId={linkedQuoteId}
                viewAll={true}
                clientEmail={queryInfo?.email_id}
                clientWebsite={queryInfo?.website_id}
                info={queryInfo}
            />
        </div>
    );
};

export default LinkedQuoteTabContent;
